import buildUrl from '@/script/buildUrl.mjs';

// 打开：制品详情页
export const openDetail = (dpId, bizNodeType, calleePkid, isMounted, prjId) => {
    // 逻辑图是mapInits
    const mapInits = isMounted ?
        {
            selectedNodes: [{
                data: { pkid: calleePkid },
                isMounted: true,
            }]
        }
        :
        {
            selectedNodes: [{
                data: { pkid: calleePkid },
                isLinked: true,
            }]
        }

    const openWindow = (url, param) => {
        if (['SA_MAP', 'BF_MAP', 'BIZ_MAP', 'SF_MAP', 'BF_MAP', 'UI_MAP', 'DATA_MAP', 'FC_MAP', 'ANA_MAP', 'ORG_MAP'].includes(bizNodeType)) {
            // 集成地图是inits
            const inits = { ...mapInits };
            if (calleePkid) {
                window.open(buildUrl(url, { inits, ...param }));
            } else {
                window.open(buildUrl(url, { ...param }));
            }
        } else {
            if (calleePkid) {
                window.open(buildUrl(url, { mapInits, ...param }));
            } else {
                window.open(buildUrl(url, { ...param }));
            }
        }
    }

    switch (bizNodeType) {
        case "BF": return openWindow('/BfDetail', { bfId: dpId });
        case "BD": return openWindow('/BdDetail', { bdId: dpId });
        case "SF": return openWindow('/SfDetail', { sfId: dpId });
        case "UC": return openWindow('/UcDetail', { sfId: dpId });
        case "UI": return openWindow('/UiDetail', { uiId: dpId });
        case "DB": return openWindow('/DbDetail', { dbId: dpId });
        case "DT": return openWindow('/DtDetail', { dtId: dpId });
        case "DV": return openWindow('/DvDetail', { dvId: dpId });
        case "CDG": return openWindow('/DmPcdgDetail', { pcdgId: dpId });
        case "CDT": return openWindow('/DmCdtDetail', { cdtId: dpId });
        case "LS": return openWindow('/LsDetail', { lsId: dpId });
        case "LSI": return openWindow('/LsiDetail', { lsiId: dpId });
        case "SS": return openWindow('/SsDetail', { ssId: dpId });
        case "FC": return openWindow('/FcDetail', { fcId: dpId });
        case "DTO": return openWindow('/DtoDetail', { dtoId: dpId });
        case "MID": return openWindow('/ArchMiddlewareDetail', { middlewareId: dpId });
        case "PHYS": return openWindow('/DepPsDetail', { psId: dpId });
        case "VR": return openWindow('/DepVsDetail', { vsId: dpId });
        case "PA": return openWindow('/PaDetail', { paId: dpId, prjId });
        case "BA": return openWindow('/BaDetail', { baId: dpId, prjId });
        case "FA": return openWindow('/FaDetail', { faId: dpId, prjId });
        case "CA": return openWindow('/CaDetail', { caId: dpId, prjId });
        case "UA": return openWindow('/UaDetail', { uaId: dpId, prjId });
        case "AA": return openWindow('/AaDetail', { aaId: dpId, prjId });
        case "OA": return openWindow('/OaDetail', { oaId: dpId, prjId });
        case "AO": return openWindow('/AoDetail', { aoId: dpId, prjId });
        case "DO": return openWindow('/DoDetail', { doId: dpId, prjId });
        case "AMAR": return openWindow('/AmArDetail', { arId: dpId, prjId });
        case "AMAI": return openWindow('/AmAiDetail', { aiId: dpId, prjId });
        case "OO": return openWindow('/OoDetail', { ooId: dpId, prjId });
        case "RULEMRM": return openWindow('/RulemRmDetail', {rmId: dpId, prjId });
        case "ISRF": return openWindow('/IsrfDetail', {isrfId: dpId, prjId });
        // 集成图
        case "SA_MAP": return openWindow('/SoftwareMap', { id: dpId });
        case "BF_MAP": return openWindow('/SoftwareMap', { id: dpId });
        case "BIZ_MAP": return openWindow('/SoftwareMap', { id: dpId });
        case "SF_MAP": return openWindow('/SoftwareMap', { id: dpId });
        case "UC_MAP": return openWindow('/SoftwareMap', { id: dpId });
        case "UI_MAP": return openWindow('/SoftwareMap', { id: dpId });
        case "DATA_MAP": return openWindow('/SoftwareMap', { id: dpId });
        case "FC_MAP": return openWindow('/SoftwareMap', { id: dpId });
        case "ANA_MAP": return openWindow('/SoftwareMap', { id: dpId });
        case "ORG_MAP": return openWindow('/SoftwareMap', { id: dpId });
    }
}
